<template>
  <div class="flex items-stretch gap-xs w-full h-[104px]">
    <div class="flex flex-col gap-m justify-start w-[399px]">
      <div class="flex flex-col gap-2xs">
        <div class="flex items-center gap-2xs">
          <Skeleton class="h-4 w-24 rounded" />
          <Skeleton class="h-4 w-32 rounded" />
        </div>
        <Skeleton class="h-5 w-3/4 rounded" />
      </div>
      <div class="flex flex-col gap-3xs">
        <Skeleton class="h-3 w-full rounded" />
        <Skeleton class="h-3 w-4/5 rounded" />
      </div>
      <Skeleton class="h-[231px] w-[162px] rounded-2xl" />
    </div>
    <Divider orientation="vertical" class="!border-blurple-200" />
  </div>
</template>
